var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.BannerMtLink, {
    attrs: { text: _setup.bannerText, "data-qa": "lpu_doctors_list_mt_banner" },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }